// extracted by mini-css-extract-plugin
export default {"requirement":"classes_requirement__R5BNr","dots":"classes_dots__IfusR"};